import React from 'react'
import Link from 'gatsby-link'

const Menu = () => (
  <section id="menu">
    <ul className="actions">
      <li>
        <Link to="/building-trust#one" className="button">
          Building Trust
        </Link>
      </li>
      <li>
        <Link to="/coaching-people#one" className="button">
          Coaching People
        </Link>
      </li>
      <li>
        <Link to="/inspiring-team#one" className="button">
          Inspiring Team
        </Link>
      </li>
      <li>
        <Link to="/encouraging-initiative#one" className="button">
          Encouraging Initiative
        </Link>
      </li>
      <li>
        <Link to="/providing-recognition#one" className="button">
          Providing Recognition
        </Link>
      </li>
    </ul>
  </section>
)

export default Menu



// WEBPACK FOOTER //
// ./src/components/Menu.js